import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18AdminsettingG = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M8.617 2.462a5.17 5.17 0 0 1 5.697-1.02.6.6 0 0 1 .177.978L12.11 4.735l.273 1.286 1.276.307 2.382-2.315a.6.6 0 0 1 .93.118l.044.086a5.17 5.17 0 0 1-1.179 5.668 5.16 5.16 0 0 1-4.93 1.28l-.104-.031-5.452 5.314a2.564 2.564 0 0 1-3.492.076l-.133-.127a2.56 2.56 0 0 1 .05-3.623l5.452-5.315-.027-.103a5.16 5.16 0 0 1 1.242-4.715zm4.178-.22a3.96 3.96 0 0 0-3.341 1.08 3.97 3.97 0 0 0-.981 4.125.6.6 0 0 1-.15.621l-5.71 5.566a1.362 1.362 0 1 0 1.9 1.954l5.711-5.565a.6.6 0 0 1 .627-.134A3.96 3.96 0 0 0 15 9.024a3.96 3.96 0 0 0 1.173-3.31l-.02-.137L14.26 7.42a.6.6 0 0 1-.459.168l-.1-.015-1.967-.474a.6.6 0 0 1-.447-.46l-.419-1.978a.6.6 0 0 1 .169-.555l1.892-1.842zm-8.44 11.587a.47.47 0 1 1-.673.654.47.47 0 0 1 .673-.654"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18AdminsettingG$1 = Svg18AdminsettingG;

export { Svg18AdminsettingG$1 as default };
